<template>
	<div>
		<titles titlename="实训能力模型" titlecontent="这里可以看到实训能力模型一些信息" :mbx="paths"></titles>
		<div class="choios">
			<div class="choiostitle">
				<div class="addButtonStyle col-xs-6 col-sm-6 col-md-6 col-lg-6">
					<p @click="addmodelbilty()" class="addButtonStyle01" style="cursor: pointer;margin-left: 0.4rem;" v-preventReClick>
						<span class="el-icon-circle-plus-outline"></span>
						<span>添加能力模型</span>
					</p>
				</div>
			</div>
			<div class="tablebox">
				<el-table :data="tableData" style="width: 100%" row-key="AMT_ID" :expand-row-keys="allexpands" @expand-change="handleExpandChange">
					<el-table-column type="expand">
						<template slot-scope="scope">
							<div class="treebox">
								<div class="treeboxrebity"><p>能力类型</p></div>
								<div class="treeboxrelist" v-if="expandabiltylist">
									<div class="treeboxreitem" v-for="(ite, idx) in expandabiltylist" :key="idx">
										<Vue2OrgTree :data="ite" :horizontal="true" label-class-name="labbleclass" />
									</div>
								</div>
							</div>
						</template>
					</el-table-column>
					<el-table-column label="能力模型名称" prop="AMT_ModelName"></el-table-column>
					<el-table-column label="创建时间">
						<template slot-scope="scope">
							<p style="color:#4ea1db;">{{ scope.row.AMT_CreateTime }}</p>
						</template>
					</el-table-column>
					<el-table-column label="备注" prop="name">
						<template slot-scope="scope">
							<div :title="scope.row.name">{{ scope.row.AMT_Describe }}</div>
						</template>
					</el-table-column>
					<el-table-column label="操作" prop="name">
						<template slot-scope="scope">
							<el-button size="small" class="looking" @click="editsnames(scope.row)">
								<el-tooltip class="item" effect="dark" content="编辑模型" placement="bottom-end">
									<span style="font-size: 16px;" class="el-icon-edit-outline"></span>
								</el-tooltip>
							</el-button>

							<el-button size="small" :class="'looking'" @click="addtypes(scope.row)">
								<el-tooltip class="item" effect="dark" content="添加/修改所属能力内容" placement="bottom-end">
									<!-- scope.row.abilitytypeslist && scope.row.abilitytypeslist.length > 0 ? '编辑模型类型' : '添加模型类型' -->
									<span style="font-size: 16px;" class="el-icon-circle-plus-outline"></span>
								</el-tooltip>
							</el-button>

							<el-button size="small" class="giveempower" @click="giveem(scope.row)">
								<el-tooltip class="item" effect="dark" content="授权设备" placement="bottom-end">
									<span style="font-size: 16px;" class="el-icon-money"></span>
								</el-tooltip>
							</el-button>

							<el-button size="small" @click="deletehandleClick(scope.row)" class="delete">
								<el-tooltip class="item" effect="dark" content="删除" placement="bottom-end">
									<span style="font-size: 16px;" class="el-icon-delete-solid"></span>
								</el-tooltip>
							</el-button>
						</template>
					</el-table-column>
				</el-table>

				<div class="elpagian">
					<el-pagination
						@current-change="changecurr"
						hide-on-single-page
						background
						layout="prev, pager, next"
						:page-size="tabsnum"
						:total="totalall"
						:current-page="tabindex"
					></el-pagination>
				</div>
			</div>
		</div>

		<el-dialog title="绑定设备" :visible.sync="giveemVisible" center width="40%">
			<el-form label-position="left" label-width="120px" :model="formLabelAlign">
				<el-form-item label="选择设备:">
					<el-select v-model="isclassid" style="width: 100%;" multiple placeholder="请选择设备">
						<el-option v-for="item in isclasslist" :key="item.sx_te_guid" :label="item.te_deviceName" :value="item.sx_te_guid"></el-option>
					</el-select>
				</el-form-item>
			</el-form>
			<span slot="footer" class="dialog-footer">
				<el-button
					@click="
						giveemVisible = false;
						formLabelAlign.classname = '';
					"
				>
					取 消
				</el-button>
				<el-button type="primary" @click="addmogiveem">确 定</el-button>
			</span>
		</el-dialog>

		<el-dialog :title="dilogname" :visible.sync="dialogVisible" center width="40%">
			<el-form label-position="left" label-width="120px" :model="formLabelAlign">
				<el-form-item label="能力模型名称:"><el-input v-model="formLabelAlign.name"></el-input></el-form-item>
				<el-form-item label="内容描述:"><el-input v-model="formLabelAlign.bztextname" type="textarea" maxlength="400" show-word-limit :rows="4"></el-input></el-form-item>
			</el-form>
			<span slot="footer" class="dialog-footer">
				<el-button
					@click="
						dialogVisible = false;
						formLabelAlign.name = '';
						formLabelAlign.bztextname = '';
						formLabelAlign.mxids = '';
					"
				>
					取 消
				</el-button>
				<el-button v-if="dilogname == '添加模型'" type="primary" @click="addmodels()">确 定</el-button>
				<el-button v-if="dilogname == '编辑模型'" type="primary" @click="editsmodels(formLabelAlign.mxids)">确 定</el-button>
			</span>
		</el-dialog>

		<el-dialog :title="typesname" :visible.sync="typesVisible" center width="73%" :before-close="handleClose">
			<el-tabs v-model="activeName" type="card" @tab-click="handleClickactiveName">
				<el-tab-pane label="添加/修改能力类型" name="1">
					<el-form label-position="left" label-width="200px" :model="formLabelAlign">
						<el-form-item label="能力类型名称：" required><el-input v-model="formLabelAlign.abilitytypename" placeholder="能力类型名称"></el-input></el-form-item>
						<el-form-item label="能力类型所占比重（%）：" required>
							<el-input
								v-model="formLabelAlign.abilityproportion"
								style="width: 140px;"
								type="number"
								min="0"
								placeholder="所占比重"
								oninput="if(value>100)value=100;if(value<0)value=0"
							></el-input>
						</el-form-item>
						<el-form-item label="是否按类型(统计)显示">
							<el-checkbox v-model="formLabelAlign.AT_ISTpyeLode" :true-label="1" :false-label="0"></el-checkbox>
						</el-form-item>
						<el-form-item label-width="260px" label="类型第二名称(用于按类型统计时使用)" v-if="formLabelAlign.AT_ISTpyeLode">
							<el-input v-model="formLabelAlign.AT_TypeLodeIsName" placeholder="类型第二名称"></el-input>
						</el-form-item>
					</el-form>
				</el-tab-pane>
				<el-tab-pane label="添加/修改能力项目" name="2">
					<el-form label-position="left" label-width="200px" :model="formLabelAlign">
						<el-form-item label="选择所属能力类型：" required>
							<el-select v-model="formLabelAlign.abilitytypename" style="width: 100%;" placeholder="请选择">
								<el-option v-for="item in abilitytypelist" :key="item.AT_ID" :label="item.AT_TypeName" :value="item.AT_TypeName"></el-option>
							</el-select>
						</el-form-item>
						<el-form-item label="能力项目名称：" required><el-input v-model="formLabelAlign.projectname" placeholder="能力项目名称"></el-input></el-form-item>
						<el-form-item label="能力项目所占比重（%）：">
							<el-input
								v-model="formLabelAlign.ATN_Proportion"
								style="width: 140px;"
								type="number"
								min="0"
								placeholder="所占比重"
								oninput="if(value>100)value=100;if(value<0)value=0"
							></el-input>
						</el-form-item>
					</el-form>
				</el-tab-pane>
			</el-tabs>
			<div class="typebtnlis" v-if="activeName == '1'"><el-button icon="el-icon-plus" @click="addbiltys()">添加</el-button></div>
			<div class="typebtnlis" v-if="activeName == '2'"><el-button icon="el-icon-plus" @click="addbiltystypes()">添加</el-button></div>
			<div class="editetables">
				<el-table
					:data="edittableData"
					row-key="AT_ID"
					:expand-row-keys="expands"
					@expand-change="expandabiltylistchange"
					max-height="600"
					border
					style="width: 100%; margin-top: 20px"
				>
					<el-table-column type="expand">
						<template slot-scope="scope">
							<div class="tableschild">
								<p v-if="scope.row.childlist.length == 0">暂无所属项目</p>
								<div class="tableschildbox" v-for="(ite, idx) in scope.row.childlist" :key="idx">
									<div class="deletes-box">
										<!-- v-if="!ite.isantedit" -->
										<span
											:title="ite.isantedit ? '编辑当前项目' : '取消编辑'"
											@click="editsisantedit(scope, idx)"
											style="margin-right: 20px;"
											class="el-icon-edit-outline"
										></span>
										<span
											v-if="ite.isantedit"
											title="保存当前项目"
											@click="savesisantedit(scope, idx)"
											style="margin-right: 20px;"
											class="el-icon-circle-check"
										></span>
										<span @click="deleteproject(scope, idx, ite)" title="删除当前项目" class="el-icon-delete-solid"></span>
									</div>
									<el-form :inline="true" :model="ite" label-position="left" class="demo-form-tables">
										<el-form-item label="能力项目名称:" class="changeslabel changeslabels" style="margin-bottom: 0;height: 30px;">
											<div style="height: 25px;line-height: 30px;" v-if="ite.isantedit">
												<el-input v-model="ite.ANI_TrainingName" class="changesheight" style="height: 100%;" placeholder="能力项目名称"></el-input>
											</div>
											<p v-else :title="ite.ANI_TrainingName" style="cursor: pointer; width: 170px;height: 30px;line-height: 30px;">
												{{ ite.ANI_TrainingName }}
											</p>
										</el-form-item>

										<el-form-item label="考核比重:" class="changeslabel" style="margin-bottom: 0;height: 30px;">
											<div v-if="ite.isantedit" style="height: 20px;line-height: 30px;">
												<input
													style="width: 50px;padding-left: 10px;height: 100%;"
													v-model="ite.ATN_Proportion"
													placeholder="输入占比"
													class="changesheight"
													type="number"
													min="0"
													oninput="if(value>100)value=100;if(value<0)value=0"
												/>
												%
											</div>
											<p v-else style="height: 30px;line-height: 30px;">{{ ite.ATN_Proportion }}%</p>
										</el-form-item>
										<el-form-item label="评判标准:" class="changeslabel" style="margin-bottom: 0;">
											<div style="min-width: 340px;" v-if="ite.isantedit">
												<textarea
													v-model="ite.ANI_AtandardText"
													placeholder="评判标准"
													id=""
													style="padding: 5px;width: 100%;border: 1px solid #ccc;border-radius: 10px;"
													rows="7"
												></textarea>
											</div>
											<p style="width: 100%;overflow: inherit;white-space: inherit;text-overflow: inherit;" v-else>{{ ite.ANI_AtandardText }}</p>
										</el-form-item>
									</el-form>
								</div>
							</div>
						</template>
					</el-table-column>
					<el-table-column prop="nums" :resizable="false" label="序号" width="50"></el-table-column>
					<el-table-column prop="name" label="能力类型名称" :resizable="false">
						<template slot-scope="scope">
							<div>
								<el-input v-if="scope.row.isedit" v-model="scope.row.AT_TypeName" style="padding-left: 20px;" placeholder="能力项目名称"></el-input>
								<p v-else>{{ scope.row.AT_TypeName }}</p>
							</div>
						</template>
					</el-table-column>
					<el-table-column label="考核比重" :resizable="false">
						<template slot-scope="scope">
							<div v-if="scope.row.isedit">
								<input style="width: 50px;" v-model="scope.row.AT_Proportion" type="number" min="0" oninput="if(value>100)value=100;if(value<0)value=0" />
								%
							</div>
							<div v-else>
								<p v-if="scope.row.AT_Proportion">{{ scope.row.AT_Proportion }}%</p>
								<p v-else>暂无占比请点击修改输入</p>
							</div>
						</template>
					</el-table-column>
					<el-table-column :resizable="false" label="是否按类型(统计)显示">
						<template slot-scope="scope">
							<div>
								<div style="text-align: left;" v-if="scope.row.isedit">
									<el-checkbox v-model="scope.row.AT_ISTpyeLode" :true-label="1" :false-label="0"></el-checkbox>
									<el-input
										v-if="scope.row.AT_ISTpyeLode"
										style="height: 40px;"
										title="类型第二名称(用于按类型统计时使用)"
										placeholder="类型第二名称(用于按类型统计时使用)"
										v-model="scope.row.AT_TypeLodeIsName"
									></el-input>
								</div>
								<div v-else>
									{{ scope.row.AT_ISTpyeLode || scope.row.AT_ISTpyeLode == 1 ? '是' : '否' }}
									<p style="margin-top: 4px;">{{ scope.row.AT_TypeLodeIsName }}</p>
								</div>
							</div>
						</template>
					</el-table-column>

					<el-table-column :resizable="false" label="操作">
						<template slot-scope="scope">
							<div class="tableslist">
								<p class="changetables" @click="deletenewtype(scope)">删除当前类型</p>
								<p class="changetables" @click="editsnewtype(scope)" v-if="!scope.row.isedit">修改当前类型</p>
								<p class="changetables" @click="saveeditsnewtype(scope)" v-if="scope.row.isedit">保存当前修改</p>
							</div>
						</template>
					</el-table-column>
				</el-table>
			</div>
		</el-dialog>
	</div>
</template>

<script>
import titles from '@/components/title/title.vue';
import Vue2OrgTree from 'vue2-org-tree';
import {
	GetGtsxAbilitymodeltbllist,
	PostGtsxAbilitymodeltbl,
	DeleteGtsxAbilitymodeltbl,
	GtsxAbilitymodeltbl,
	UpdateGtsxAbilitymodeltbl,
	DeviceOrAbility,
	// 院校不分页
	GetSchoolList,
	GettrainingEquipment,
	// 删除类型
	DeleteAbilityType,
	// 添加类型
	PostAbilityType,
	// 修改类型
	UpdateAbilityType,
	// 新增项目
	PostAbilityNexusInfo,
	// 删除项目
	DeleteAbilityNexusInfo,
	// 修改项目
	UpdateAbilityTypenexus
} from '@/request/api/homesview/yunhomes/yunhom.js';

import { GetyyTrainEquipmentList } from '@/request/api/dataorder/dataprder.js';

import AppOptions from '@/config/AppOptions.vue';

export default {
	data() {
		return {
			// 标题
			paths: [
				{
					path: '/userabilitymodel/userabilitymodel',
					name: '实训能力模型'
				}
			],
			edittableData: [],
			tableData: [],
			isctive: true,
			// 树形结构
			Abilitytrees: [],
			tabsnum: 10,
			totalall: 10,
			tabindex: 1,
			dialogVisible: false,
			formLabelAlign: {
				name: '',
				bztextname: '',
				classname: '',
				abilitytypename: '',
				projectname: '',
				abilityproportion: '',
				ATN_Proportion: '',
				AT_ISTpyeLode: 0,
				AT_TypeLodeIsName: '',
				mxids: ''
			},
			dilogname: '添加模型',
			giveemVisible: false,
			options: [],
			editsname: '添加能力类型',
			editsVisible: false,
			typesname: '添加能力类型',
			typesVisible: false,
			// 获取院校以及班级
			isschoolid: '',
			isschoollist: [],
			isclassid: [],
			isclasslist: [],
			ANI_AtandardText: [{ 优秀: { max: 100, min: 90 }, 良好: { max: 89, min: 80 }, 一般: { max: 79, min: 60 }, 未掌握: { max: 59, min: 0 } }],
			isabilityty: false,
			activeName: '1',
			// 展开
			expandabiltylist: [],
			// 获取row的key值
			getRowKeys(row) {
				return row.AMT_ID;
			},
			// 要展开的行，数值的元素是row的key值
			expands: [],
			allexpands: []
		};
	},
	components: {
		titles,
		Vue2OrgTree
	},
	mounted() {
		this.inits();
	},
	created() {
		AppOptions.appEmpty = false;
	},
	computed: {
		abilitytypelist() {
			if (this.edittableData.length > 0) {
				let islisttable = [];
				this.edittableData.forEach(ite => {
					islisttable.push({
						AT_TypeName: ite.AT_TypeName,
						AT_ID: ite.AT_ID
					});
				});
				const result = Array.from(new Set(islisttable));
				return result;
			}
			return [];
		}
	},
	methods: {
		inits() {
			GetGtsxAbilitymodeltbllist({
				pageIndex: this.tabindex,
				pageSize: this.tabsnum,
				where: ''
			}).then(res => {
				// console.log(res.data.data, '获取list');
				this.totalall = res.data.data.totalCount;
				this.tableData = res.data.data.list;
				if (this.tableData.length > 0) {
					this.tableData.forEach(ite => {
						ite.abilitytypeslist.forEach(it => {
							it.label = it.AT_TypeName + '（' + (it.AT_Proportion ?? '') + '%）';
							it.id = it.AT_ID;
							it.abilitynexusinfoslist.forEach(ability => {
								ability.label = ability.ANI_TrainingName + '（' + ability.ATN_Proportion + '%）';
								ability.id = ability.ANI_ID;
							});
							it.children = it.abilitynexusinfoslist;
							it.childlist = it.abilitynexusinfoslist;
						});

						ite.abilitytypeslist.sort((a, b) => a.childlist.length - b.childlist.length);
					});
				}
			});
		},
		expandabiltylistchange(val, expandedRows) {
			if (expandedRows.length > 1) {
				expandedRows.shift();
				this.expands = [expandedRows.shift().AT_ID];
			}
		},
		async handleExpandChange(val, expandedRows) {
			// console.log(expandedRows.length,'长度');
			// 点击展开
			if (expandedRows.length > 0) {
				let Abilitydata = await GtsxAbilitymodeltbl({ AMT_ID: val.AMT_ID });
				let listobj = Abilitydata.data?.data;
				// console.log(expandedRows.length,'长度');
				if (listobj) {
					listobj.abilitytypeslist.forEach(it => {
						it.label = it.AT_TypeName + '（' + (it.AT_Proportion ?? '') + '%）';
						it.id = it.AT_ID;
						it.abilitynexusinfoslist.forEach(ability => {
							ability.label = ability.ANI_TrainingName + '（' + ability.ATN_Proportion + '%）';
							ability.id = ability.ANI_ID;
						});
						it.children = it.abilitynexusinfoslist;
					});
					this.expandabiltylist = listobj.abilitytypeslist;
					// console.log(this.expandabiltylist, '展开');
				}
				if (expandedRows.length > 1) {
					expandedRows.shift();
					this.allexpands = [expandedRows.shift().AMT_ID];
				}
			} else {
				// console.log(expandedRows.length,'长度');
				return;
			}
		},

		handleClickactiveName() {
			// console.log(tab, event);
			this.formLabelAlign.abilityproportion = '';
			this.formLabelAlign.abilitytypename = '';
		},
		// 编辑当前项目
		editsisantedit(val, idx) {
			let childoedit = this.edittableData[val.$index].childlist[idx].isantedit;
			this.edittableData[val.$index].childlist[idx].isantedit = !this.edittableData[val.$index].childlist[idx].isantedit;
			// console.log(childoedit);
		},
		// 保存当前项目
		async savesisantedit(val, idx) {
			// console.log(val, idx);
			let saveobjs = {
				ANI_ID: this.edittableData[val.$index].childlist[idx].ANI_ID,
				ANI_TrainingName: this.edittableData[val.$index].childlist[idx].ANI_TrainingName,
				ANI_Total: this.edittableData[val.$index].childlist[idx].ANI_Total ?? '',
				AT_ID: this.edittableData[val.$index].childlist[idx].AT_ID,
				ANI_AtandardText: this.edittableData[val.$index].childlist[idx].ANI_AtandardText,
				ATN_Proportion: this.edittableData[val.$index].childlist[idx].ATN_Proportion
			};
			// console.log(saveobjs, '保存对象');
			let UpdateAbility = await UpdateAbilityTypenexus(saveobjs);
			// console.log(UpdateAbility.data);
			if (UpdateAbility.data && UpdateAbility.data.code > 0) {
				this.$message({
					type: 'success',
					message: '保存成功!'
				});
				this.edittableData[val.$index].childlist[idx].isantedit = false;
			} else {
				this.$message('出现错误');
			}
		},

		// 删除当前项目
		deleteproject(val, idx, childitem) {
			this.$confirm('改操作将删除当前项目, 是否继续?', '提示', {
				confirmButtonText: '确定',
				cancelButtonText: '取消',
				type: 'warning'
			})
				.then(async () => {
					this.edittableData[val.$index].childlist.splice(this.edittableData[val.$index].childlist.indexOf(childitem), 1);
					let DeleteAbnexuobj = await DeleteAbilityNexusInfo({
						ANI_ID: childitem.ANI_ID
					});
					if (DeleteAbnexuobj.data && DeleteAbnexuobj.data.code > 0) {
						this.$message({
							type: 'success',
							message: '删除成功!'
						});
					}
				})
				.catch(() => {});
		},
		// 添加能力类型
		async addbiltys() {
			if (this.formLabelAlign.abilitytypename == '') {
				this.$message('请输入能力项目类型');
				return;
			}

			let addobjs = {
				AT_TypeName: this.formLabelAlign.abilitytypename,
				AT_Proportion: this.formLabelAlign.abilityproportion,
				AMT_ID: this.formLabelAlign.mxids,
				AT_Sort: this.edittableData.length + 1,
				AT_Describe: '',
				AT_ISTpyeLode: this.formLabelAlign.AT_ISTpyeLode == 1 ? true : false,
				AT_TypeLodeIsName: this.formLabelAlign.AT_TypeLodeIsName
			};

			let Postobjs = await PostAbilityType(addobjs);
			if (Postobjs.data.code && Postobjs.data.code > 0) {
				let Abilitydata = await GtsxAbilitymodeltbl({ AMT_ID: this.formLabelAlign.mxids });
				if (Abilitydata.data.data.abilitytypeslist && Abilitydata.data.data.abilitytypeslist.length > 0) {
					Abilitydata.data.data.abilitytypeslist.forEach((ite, idx) => {
						ite.abilitynexusinfoslist.forEach(it => {
							it.isantedit = false;
						});

						ite.childlist = ite.abilitynexusinfoslist;
						ite.nums = idx + 1;
						ite.AT_ISTpyeLode = ite.AT_ISTpyeLode ? 1 : 0;
					});
					this.edittableData = Abilitydata.data.data.abilitytypeslist;
				}
			}
			this.formLabelAlign.abilitytypename = '';
			this.formLabelAlign.abilityproportion = '';
			this.formLabelAlign.projectname = '';
			this.formLabelAlign.ATN_Proportion = '';
			this.formLabelAlign.AT_ISTpyeLode = false;
			this.formLabelAlign.AT_TypeLodeIsName = '';
		},
		// 添加项目
		async addbiltystypes() {
			if (this.formLabelAlign.abilitytypename == '') {
				this.$message('请选择能力类型');
				return;
			}
			if (this.formLabelAlign.projectname == '') {
				this.$message('请输入能力项目');
				return;
			}
			this.expands = [];
			// 获取相同的index，添加项目
			const index = this.edittableData.findIndex(obj => obj.AT_TypeName === this.formLabelAlign.abilitytypename);
			if (index > -1) {
				let upobjs = {
					ANI_TrainingName: this.formLabelAlign.projectname,
					ANI_Total: '',
					ANI_AtandardText: JSON.stringify(this.ANI_AtandardText),
					ATN_Proportion: this.formLabelAlign.ATN_Proportion,
					AT_ID: this.edittableData[index].AT_ID
				};
				let AbilityNexus = await PostAbilityNexusInfo(upobjs);
				if (this.expands.includes(this.edittableData[index].AT_ID)) {
					this.expands = this.expands.filter(val => val !== this.edittableData[index].AT_ID);
				} else {
					this.expands.push(this.edittableData[index].AT_ID);
				}
				// console.log(this.expands, '获取展开行');
				if (AbilityNexus && AbilityNexus.data.code > 0) {
					let Abilitydata = await GtsxAbilitymodeltbl({ AMT_ID: this.formLabelAlign.mxids });
					if (Abilitydata.data.data.abilitytypeslist && Abilitydata.data.data.abilitytypeslist.length > 0) {
						Abilitydata.data.data.abilitytypeslist.forEach((ite, idx) => {
							ite.abilitynexusinfoslist.forEach(it => {
								it.isantedit = false;
							});

							ite.childlist = ite.abilitynexusinfoslist;
							ite.nums = idx + 1;
							ite.AT_ISTpyeLode = ite.AT_ISTpyeLode ? 1 : 0;
						});
						this.edittableData = Abilitydata.data.data.abilitytypeslist;
					}
				}
			}
			// this.formLabelAlign.abilitytypename = '';
			this.formLabelAlign.projectname = '';
			this.formLabelAlign.ATN_Proportion = '';

			/* 
			 let objs = {
			 	AT_TypeName: this.formLabelAlign.abilitytypename,
			 	AT_Proportion: '',
			 	ANI_TrainingName: this.formLabelAlign.projectname,
			 	ATN_Proportion: this.formLabelAlign.ATN_Proportion,
			 	ANI_AtandardText: JSON.stringify(this.ANI_AtandardText)
			 };*/
		},
		// 删除当前类型
		deletenewtype(val) {
			this.$confirm('当前操作将删除当前类型, 是否继续?', '提示', {
				confirmButtonText: '确定',
				cancelButtonText: '取消',
				type: 'warning'
			})
				.then(async () => {
					let DeleteAbility = await DeleteAbilityType({
						AT_ID: val.row.AT_ID
					});
					// console.log(DeleteAbility, '删除');

					if (DeleteAbility.data.code > 0) {
						let Abilitydata = await GtsxAbilitymodeltbl({ AMT_ID: this.formLabelAlign.mxids });
						if (Abilitydata.data.data.abilitytypeslist && Abilitydata.data.data.abilitytypeslist.length > 0) {
							Abilitydata.data.data.abilitytypeslist.forEach((ite, idx) => {
								ite.abilitynexusinfoslist.forEach(it => {
									it.isantedit = false;
								});

								ite.childlist = ite.abilitynexusinfoslist;
								ite.nums = idx + 1;
								ite.AT_ISTpyeLode = ite.AT_ISTpyeLode ? 1 : 0;
							});
							this.edittableData = Abilitydata.data.data.abilitytypeslist;
						} else {
							this.edittableData = [];
						}
						this.$message({
							type: 'success',
							message: '删除成功!'
						});
					}
				})
				.catch(() => {});
		},
		// 修改当前类型
		editsnewtype(val) {
			this.edittableData[val.$index].isedit = true;
		},
		// 保存修改
		async saveeditsnewtype(val) {
			let editobjs = {
				AT_ID: val.row.AT_ID,
				AT_TypeName: val.row.AT_TypeName,
				AT_Proportion: val.row.AT_Proportion,
				AT_Sort: val.row.nums,
				AMT_ID: val.row.AMT_ID,
				AT_Describe: '',
				AT_ISTpyeLode: val.row.AT_ISTpyeLode == 0 ? false : true,
				AT_TypeLodeIsName: val.row.AT_ISTpyeLode == 0 ? '' : val.row.AT_TypeLodeIsName
			};
			if (this.edittableData[val.$index].AT_ISTpyeLode == 0) {
				this.edittableData[val.$index].AT_TypeLodeIsName = '';
			}
			// console.log(editobjs, '获取当前修改类型');
			let scussobj = await UpdateAbilityType(editobjs);
			if (scussobj.data.code > 0) {
				this.$message.success('修改成功');
				this.edittableData[val.$index].isedit = false;
			}

			// UpdateAbilityType()
		},

		// 点击编辑
		editetypes() {
			// console.log('编辑1111');
		},

		changecurr(val) {
			this.tabindex = val;
			this.inits();
		},
		rectsbiltys() {
			this.formLabelAlign.abilityproportion = '';
			this.formLabelAlign.projectname = '';
			this.formLabelAlign.abilitytypename = '';
		},

		editsnames(val) {
			// console.log(val,'获取')
			this.formLabelAlign.name = val.AMT_ModelName;
			this.formLabelAlign.bztextname = val.AMT_Describe;
			this.formLabelAlign.mxids = val.AMT_ID;
			this.formLabelAlign.abilitytypeslist = val.abilitytypeslist;

			this.dialogVisible = true;
			this.dilogname = '编辑模型';
		},
		addmodels() {
			let obj = {
				AMT_ModelName: this.formLabelAlign.name,
				AMT_ID: '',
				AMT_Describe: this.formLabelAlign.bztextname,
				abilitytypeslist: this.formLabelAlign.abilitytypeslist ?? []
			};

			PostGtsxAbilitymodeltbl(obj).then(res => {
				// console.log(res, '添加');
				if (res.data.code == 1) {
					this.formLabelAlign.name = '';
					this.formLabelAlign.bztextname = '';
					this.formLabelAlign.mxids = '';
					this.dialogVisible = false;
					this.inits();
				}
			});
		},
		// 编辑模型
		editsmodels(id) {
			// console.log(id);

			let obj = {
				AMT_ModelName: this.formLabelAlign.name,
				AMT_ID: id ?? '',
				AMT_Describe: this.formLabelAlign.bztextname,
				abilitytypeslist: this.formLabelAlign.abilitytypeslist ?? []
			};

			UpdateGtsxAbilitymodeltbl(obj).then(res => {
				// console.log(res, '添加');
				if (res.data.code == 1) {
					this.formLabelAlign.name = '';
					this.formLabelAlign.bztextname = '';
					this.formLabelAlign.mxids = '';
					this.dialogVisible = false;
					this.inits();
				}
			});
		},
		// 授权
		addmogiveem() {
			// console.log(this.isclassid)
			if (this.isclassid.length == 0) {
				this.$message('请选择班级');
				return;
			}
			let isclassid = [];
			this.isclassid.forEach(ite => {
				isclassid.push({
					sx_te_guid: ite
				});
			});
			let abilityobj = {
				AMT_ID: this.formLabelAlign.mxids,
				Telist: isclassid
			};

			DeviceOrAbility(abilityobj).then(res => {
				// console.log('授权模型', res.data.code);
				if (res.data.code > 0) {
					this.$message.success('操作成功');
					this.giveemVisible = false;
				}
			});
		},
		// 弹窗关闭
		handleClose(done) {
			this.$confirm('确认关闭？')
				.then(_ => {
					done();
				})
				.catch(_ => {});
		},
		// 添加模型
		addmodelbilty() {
			// console.log('添加模型');
			this.formLabelAlign.name = '';
			this.formLabelAlign.bztextname = '';
			this.dilogname = '添加模型';
			this.dialogVisible = true;
		},
		// 添加/修改所属能力内容
		async addtypes(val) {
			this.rectsbiltys();

			let Abilitydata = await GtsxAbilitymodeltbl({ AMT_ID: val.AMT_ID });

			if (Abilitydata.data.data.abilitytypeslist && Abilitydata.data.data.abilitytypeslist.length > 0) {
				Abilitydata.data.data.abilitytypeslist.forEach((ite, idx) => {
					ite.abilitynexusinfoslist.forEach(it => {
						it.isantedit = false;
					});

					ite.childlist = ite.abilitynexusinfoslist;
					ite.nums = idx + 1;
					ite.AT_ISTpyeLode = ite.AT_ISTpyeLode ? 1 : 0;
					ite.isedit = false;
				});
				val.abilitytypeslist = Abilitydata.data.data.abilitytypeslist;
			}

			this.formLabelAlign.name = val.AMT_ModelName;
			this.formLabelAlign.bztextname = val.AMT_Describe;
			this.formLabelAlign.mxids = val.AMT_ID;
			this.edittableData = [];
			if (val.abilitytypeslist && val.abilitytypeslist.length > 0) {
				this.typesname = '编辑模型类型';
				this.edittableData = val.abilitytypeslist;
			} else {
				this.typesname = '添加模型类型';
			}
			if (val.abilitytypeslist.length == 0) {
				this.edittableData = [];
			}

			this.typesVisible = true;
		},

		// 更改院校获取班级
		changeschoolid() {
			// 更改院校获取班级
			this.isclassid = [];
			GetyyTrainEquipmentList(this.isschoolid).then(re => {
				// console.log(re, '获取设备列表列表');
				this.isclasslist = re.data.data;
				if (this.isclasslist && this.isclasslist.length > 0) {
					GettrainingEquipment({
						AMT_ID: this.formLabelAlign.mxids,
						si_guid: this.isschoolid
					}).then(quipment => {
						// console.log(quipment.data.data);
						// this.activeclasslist = quipment.data.data;
						if (quipment.data.data && quipment.data.data.length > 0) {
							quipment.data.data.forEach(isactiveite => {
								this.isclassid.push(isactiveite.sx_te_guid);
							});
						}
					});
				}
			});
		},
		// 授权
		giveem(val) {
			this.formLabelAlign.mxids = val.AMT_ID;
			this.isclassid = [];
			// console.log(val,'获取当前对象')
			// 获取院校
			GetSchoolList().then(res => {
				// console.log(res,'获取院校')
				this.isschoollist = res.data.data;
				if (res.data.data.length > 0) {
					this.isschoolid = this.isschoollist[0].si_guid;
					if (this.isschoolid) {
						let scoolid = this.isschoolid;
						let userssUserRoleList = JSON.parse(localStorage.getItem('userss'))?.UserRoleList;
						console.log(userssUserRoleList,'获取')
						let someusers = userssUserRoleList.some(ite => ite.rl_guid == '4b58b16e0f4b4cdf9056fd299edb5373');
						if (someusers) {
							scoolid = '';
						}
						GetyyTrainEquipmentList(scoolid).then(re => {
							// console.log(re, '获取设备列表');
							this.isclasslist = re.data.data;
							if (this.isclasslist.length > 0) {
								GettrainingEquipment({
									AMT_ID: val.AMT_ID,
									si_guid: this.isschoolid
								}).then(quipment => {
									// console.log(quipment.data.data);
									// this.activeclasslist = quipment.data.data;
									quipment.data.data.forEach(isactiveite => {
										if (isactiveite.IsMX) {
											this.isclassid.push(isactiveite.sx_te_guid);
										}
									});

									this.giveemVisible = true;
								});
							}
						});
					}
				}
			});
		},

		deletehandleClick(val) {
			this.$confirm('此操作将删除该模型, 是否继续?', '提示', {
				confirmButtonText: '确定',
				cancelButtonText: '取消',
				type: 'warning'
			})
				.then(() => {
					DeleteGtsxAbilitymodeltbl({
						AMT_ID: val.AMT_ID
					}).then(res => {
						// console.log(res, '删除111');
						if (res.data.code == 1) {
							this.inits();
							this.$message({
								type: 'success',
								message: '删除成功!'
							});
						}
					});
				})
				.catch(() => {});
		}
	}
};
</script>

<!-- 
添加类型
			// if (this.edittableData.length == 0) {
			// 	this.edittableData.push({
			// 		AT_TypeName: this.formLabelAlign.abilitytypename,
			// 		AT_Proportion: this.formLabelAlign.abilityproportion,
			// 		ANI_TrainingName: '',
			// 		ATN_Proportion: '',
			// 		AT_ISTpyeLode: this.formLabelAlign.AT_ISTpyeLode,
			// 		AT_TypeLodeIsName: this.formLabelAlign.AT_TypeLodeIsName,
			// 		childlist: [],
			// 		ANI_AtandardText: ''
			// 	});
			// } else {
			// 	if (this.edittableData.length > 0) {
			// 		//  判断数组里面的名称有没有重复的，如果没有重复的就有直接push并且加上 childrennum
			// 		// 使用some方法来判断是否有对象的id等于valueToFind
			// 		const isValueFound = this.edittableData.some(obj => obj.AT_TypeName === this.formLabelAlign.abilitytypename);
			// 		if (isValueFound) {
			// 			// console.log('这里有相等的，就提示不能添加')
			// 			this.$message('当前所添加的类型已存在');
			// 			return;
			// 		} else {
			// 			// console.log('这里没有相等的，无需做逻辑判断')
			// 			this.edittableData.push({
			// 				AT_TypeName: this.formLabelAlign.abilitytypename,
			// 				AT_Proportion: this.formLabelAlign.abilityproportion,
			// 				ANI_TrainingName: '',
			// 				ATN_Proportion: '',
			// 				childlist: [],
			// 				ANI_AtandardText: '',
			// 				AT_ISTpyeLode: this.formLabelAlign.AT_ISTpyeLode,
			// 				AT_TypeLodeIsName: this.formLabelAlign.AT_TypeLodeIsName
			// 			});
			// 		}
			// 	}
			// }



// 更改swich
		switchChangeFin(e) {
			console.log(e);
		},	
// 筛选
		objectSpanMethod({ row, column, rowIndex, columnIndex }) {
			if (columnIndex === 1 || columnIndex === 2 || columnIndex === 3) {
				if (row.childrennum) {
					// console.log(row.childrennum,'这里有值')
					return {
						rowspan: row.childrennum,
						colspan: 1
					};
				} else {
					return {
						rowspan: 0,
						colspan: 0
					};
				}
			}
		}
<span slot="footer" class="dialog-footer">
				<el-button
					@click="
						typesVisible = false;
						formLabelAlign.abilitytypename = '';
						formLabelAlign.projectname = '';
						formLabelAlign.proportion = '';
					"
				>
					取 消
				</el-button>
				<el-button type="primary" @click="addtypesokk">确 定</el-button>
			</span>



addtypesokk() {
			const outputData = [];

			const AT_TypeNames = this.edittableData.map(item => item.AT_TypeName);
			const uniqueAT_TypeNames = [...new Set(AT_TypeNames)];

			uniqueAT_TypeNames.forEach((AT_TypeName, idx) => {
				const data = this.edittableData.filter(item => item.AT_TypeName === AT_TypeName);
				const AT_Proportion = parseInt(data[0].AT_Proportion);
				const AT_Describe = '';
				const AT_Sort = idx + 1;
				const AMT_ID = this.formLabelAlign.mxids;

				const abilitynexusinfoslist = data.map(item => {
					return {
						ANI_TrainingName: item.ANI_TrainingName,
						ATN_Proportion: item.ATN_Proportion,
						ANI_AtandardText: item.ANI_AtandardText
					};
				});

				outputData.push({
					AT_TypeName,
					AT_Proportion,
					AT_Describe,
					AT_Sort,
					AMT_ID,
					abilitynexusinfoslist
				});
			});

			if (outputData) {
				if (this.typesname == '添加模型类型') {
					PostGtSxAbilityType(outputData).then(res => {
						// console.log('添加模型内容', res);
						if (res.data.code > 0) {
							this.$message.success(res.data.msg);
							this.formLabelAlign.name = '';
							this.formLabelAlign.bztextname = '';
							this.formLabelAlign.mxids = '';
							this.formLabelAlign.abilitytypename = '';
							this.formLabelAlign.projectname = '';
							this.formLabelAlign.abilityproportion = '';
							this.typesVisible = false;
							this.inits();
						} else {
							this.$message.success(res.data.msg);
						}
					});
				} else if (this.typesname == '编辑模型类型') {
					let Updateobj = {
						AMT_ModelName: this.formLabelAlign.name,
						AMT_ID: this.formLabelAlign.mxids,
						AMT_Describe: this.formLabelAlign.bztextname,
						abilitytypeslist: outputData
					};

					UpdateGtsxAbilitymodeltbl(Updateobj).then(res => {
						// console.log(res, '添加');
						if (res.data.code == 1) {
							this.formLabelAlign.name = '';
							this.formLabelAlign.bztextname = '';
							this.formLabelAlign.mxids = '';
							this.typesVisible = false;
							this.inits();
						}
					});
				}
			}
			// console.log(outputData, '转换');
		}, 
 
 
 -->
<style lang="less">
@import './style.css';

.tableschild {
	display: flex;
	flex-wrap: wrap;
	// justify-content: center;
	margin: 0 auto;
	padding: 20px;
	padding-left: 50px;

	.tableschildbox {
		width: 30%;
		overflow: hidden;
		height: 110px;
		display: flex;
		flex-direction: column;
		background-color: #fff;
		border: 1px solid #ccc;
		box-sizing: border-box;
		padding: 20px;
		border-radius: 12px;
		box-shadow: 17px -4px 15px 4px rgba(0, 0, 0, 0.08);
		margin-top: 10px;
		margin-right: 20px;
		transition: all 1s;

		&:hover {
			height: 350px;
			max-height: 1000px;
			background-color: #7bcc7b;
			.el-form-item__label {
				color: #fff !important;
				font-weight: 700;
			}

			p {
				color: #fff !important;
				font-weight: 700;
			}
		}

		.deletes-box {
			width: 100%;
			display: flex;
			justify-content: flex-end;
			font-size: 18px;
			margin-bottom: 4px;

			span:first-child {
				color: #1e80ff;
				cursor: pointer;
			}

			span:nth-of-type(2) {
				color: #1e80ff;
				cursor: pointer;
			}

			span:last-child {
				color: #ff0000;
				cursor: pointer;
			}
		}

		.demo-form-tables {
			display: flex;
			flex-direction: column;

			.changeslabel {
				.el-form-item__label {
					height: 30px !important;
					line-height: 30px !important;
				}
			}

			.changesheight {
				.el-input__inner {
					height: 100% !important;
				}
				input {
					padding-left: 10px;
				}
			}
			// .changeslabels {
			// 	.el-form-item__content {
			// 		height: 30px !important;
			// 	}
			// }
		}
	}
}

.downsbox {
	position: absolute;
	background: #fff;
	z-index: 999;
	padding: 0 20px;
	// border: 1px solid #ccc;
	border-radius: 8px;
	width: 100%;
	max-height: 210px;
	overflow-y: scroll;
	height: 0;

	p {
		cursor: pointer;
	}
}

.activesdownsbox {
	border: 1px solid #ccc;
	height: auto;
}
// 滚动条区域的宽度
.downsbox::-webkit-scrollbar {
	width: 4px;
}
/* 滚动槽的样式设置 */
.downsbox::-webkit-scrollbar-track {
	-webkit-box-shadow: inset 0 0 6px rgba(255, 255, 255, 0.5);
}
/* 滚动条滑块的样式设置 */
.downsbox::-webkit-scrollbar-thumb {
	background: rgba(0, 0, 0, 0.1);
	-webkit-box-shadow: inset 0 0 6px rgba(39, 167, 148);
}
.downsbox::-webkit-scrollbar-thumb:window-inactive {
	background: rgba(255, 0, 0, 0.4);
}

.treeboxrebity {
	display: flex;
	align-items: center;
	padding-left: 40px;
	cursor: pointer;
	p {
		font-size: 16px;
		font-weight: 700;
		color: #333;
	}
	button {
		cursor: pointer;
		margin-left: 10px;
		padding: 0 10px;
		color: #fff;
		background-color: rgb(2, 131, 15);
	}
}

.editetables {
	input {
		border: 1px solid #333;
		padding: 2px 0;
		border-radius: 4px;
	}

	.tableslist {
		display: flex;
		align-items: center;
		flex-wrap: wrap;
		width: 100%;
		// padding: 0 20px;

		.changetables {
			width: 44%;
			margin-right: 4px;
			color: #1e80ff;
			font-weight: 400;
			cursor: pointer;
			text-decoration: underline;
			margin-right: 10px;
			margin-top: 10px;
		}
	}
}

.typebtnlis {
	display: flex;
	align-items: center;
	justify-content: flex-start;

	button:first-child {
		background-color: rgba(255, 92, 0, 1);
		color: #fff;
	}

	// button:last-child {
	// 	background-color: rgba(215, 215, 215, 1);
	// 	color: #333;
	// }
}

.elpagian {
	margin-top: 30px;
	width: 100%;
	display: flex;
	align-items: center;
	justify-content: flex-end;
}

.treebox {
	display: flex;
	align-items: flex-start;
	justify-content: space-between;
	flex-direction: column;
	flex-wrap: wrap;
	position: relative;
	z-index: 999;
	padding-bottom: 100px;
	pointer-events: none;

	.treeboxrelist {
		display: flex;
		align-items: flex-start;
		// justify-content: space-between;
		flex-direction: column;
		flex-wrap: wrap;
		width: 100%;

		.treeboxreitem {
			width: 100%;
			display: flex;
			// align-items: flex-start;
		}
	}

	.org-tree-node-label {
		div {
			pointer-events: none;
			background-color: rgba(2, 167, 240, 1);
			color: #fff;
		}
	}
	.org-tree-node-children {
		pointer-events: none;
		.org-tree-node-label-inner {
			pointer-events: none;
			background-color: rgba(112, 182, 3, 1);
		}
	}
}
</style>

<style scoped lang="less">
.choiostitle {
	display: flex;
	padding: 0.8rem 1rem;
	align-items: center;
	justify-content: space-between;
	background-color: #fff;
	margin-bottom: 1rem;
	border-left: 4px solid rgba(247, 173, 58, 1);
	.addButtonStyle {
		display: flex;
		.addButtonStyle01 {
			color: white;
			font-size: 1rem;
			background-color: #f7ad3a;
			border: 1px solid #f7ad3a;
			padding: 0.4rem 1rem;
			border-radius: 0.2rem;
			margin-right: 0.5rem;
		}
	}
}

/deep/ .el-checkbox {
	.el-checkbox__inner {
		border-color: #000;
	}
}

/deep/ .el-table {
	th {
		text-align: center;
	}
	td {
		text-align: left;
	}

	tr {
		background-color: transparent !important; /* 或者设置为你想要的背景颜色 */
		opacity: 1 !important;
	}

	.el-table__expand-icon {
		margin-bottom: 10px !important;
	}

	.el-table__expand-column {
		.el-table__expand-icon {
			font-size: 18px;
		}
	}

	td {
		button {
			color: #fff;
			border-radius: 5px;
		}

		.looking {
			background: #0acf97;
			margin-left: 10px;
		}

		.looking:hover {
			background: #0ae8a6;
		}

		.giveempower {
			background: #ff8300;
		}

		.edit {
			background: #169bd5;
		}

		.edit:hover {
			background: #18aceb;
		}

		.delete {
			background: #f2125e;
			margin-left: 0.5rem;
		}

		.delete:hover {
			background: #ff1365;
		}
	}

	.expanded {
		// background-color: #add8e6 !important; /* 浅蓝色背景 */
		td {
			font-weight: 700;

			// &:hover {
			// 	background-color: #add8e6 !important; /* 或者设置为你想要的背景颜色 */
			// }
		}
	}

	/* 首先去除默认的hover效果 */
	// .el-table--enable-row-hover .el-table__body tr:hover > td {
	// 	background-color: rgba(0, 0, 0, 0) !important;
	// }
}

.tablebox {
	/deep/ .el-table {
		td {
			text-align: center;
		}
	}
}

.swipers {
	/deep/ .el-switch {
		line-height: 28px;
		height: 28px;
	}
	/deep/ .switchStyle .el-switch__label {
		position: absolute;
		display: none;
		color: #ffffff !important;
	}

	/deep/ .switchStyle .el-switch__label--left {
		z-index: 9;
		left: 25px;
	}

	/deep/ .switchStyle .el-switch__label--right {
		z-index: 9;
		left: 0px;
		top: 0;
	}

	/deep/ .switchStyle .el-switch__label.is-active {
		display: block;
	}

	/deep/ .switchStyle.el-switch .el-switch__core,
	/deep/ .el-switch .el-switch__label {
		width: 60px !important;
	}

	/deep/ .el-switch__label {
		z-index: 1 !important;
	}
}
</style>
